import type { Metric } from 'web-vitals'

const GA_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim()

function sendToGoogleAnalytics(metric: Metric): void {
  const gtag = (window as { gtag?: (...args: unknown[]) => void }).gtag
  if (!gtag || !GA_ID) return

  gtag('event', metric.name, {
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    event_category: 'Web Vitals',
    event_label: metric.id,
    non_interaction: true,
    metric_rating: metric.rating,
    metric_delta: metric.delta,
    metric_navigation_type: metric.navigationType,
  })
}

/** Mesure Core Web Vitals — import différé pour ne pas gonfler le bundle initial. */
export async function initWebVitals(): Promise<void> {
  if (!GA_ID && !import.meta.env.DEV) return

  const { onCLS, onFCP, onINP, onLCP, onTTFB } = await import('web-vitals')

  const report = (metric: Metric) => {
    if (import.meta.env.DEV) {
      console.debug(`[CWV] ${metric.name}`, metric.value, metric.rating)
    }
    sendToGoogleAnalytics(metric)
  }

  onCLS(report)
  onINP(report)
  onLCP(report)
  onFCP(report)
  onTTFB(report)
}
